import React from 'react';
import { Users } from 'phosphor-react';

import pdfImage from '../../assets/pdf.png';

import {
  Actions,
  AcessosButton,
  Button,
  Container,
  Info,
  Infos,
  NomePaciente,
  Photo,
  Row,
  StatusAguardando,
  StatusConcluido,
  TextStatus,
} from './styles';

interface LaudoExame {
  cdLaudo: string;
  cdPedRx: string;
  nmPaciente: string;
  dtLaudo: string;
  isRecebimento?: boolean;
  dsExame: string;
  nrControle: string;
  from: 'PHATO' | 'LAUREANO' | 'HNSN' | 'LAUREANO_MV2000';
  status: string;
  visualizado: boolean;
  dhVisualizacao?: string;
  selected?: boolean;
  selectable?: boolean;
  pdfDisabled?: boolean;
  isAdmin?: boolean;
  onSelect?: () => void;
  onPdfClick?: () => void;
  onAcessosClick?: () => void;
}

function isStatusConcluido(status: string) {
  const normalizedStatus = status
    ?.normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toUpperCase();

  return normalizedStatus?.startsWith('CONCLU') === true;
}

export function ExameCard({
  cdLaudo,
  nmPaciente,
  dsExame,
  dtLaudo,
  isRecebimento = false,
  nrControle,
  from,
  status,
  visualizado,
  dhVisualizacao,
  selected = false,
  selectable = false,
  pdfDisabled = false,
  isAdmin = false,
  onSelect,
  onPdfClick,
  onAcessosClick,
}: LaudoExame) {
  const isConcluido = isStatusConcluido(status);
  const dataExibida = dtLaudo
    ? isRecebimento
      ? `Recebimento: ${dtLaudo}`
      : dtLaudo
    : '';

  async function handleNavigateTolLaudoViewer() {
    sessionStorage.setItem('@cedapp:from', from);
    const url = `/laudo/${cdLaudo}`;
    window.open(url, '_blank');
  }

  function handlePdfClick(event: React.MouseEvent<HTMLButtonElement>) {
    event.stopPropagation();

    if (pdfDisabled) {
      return;
    }

    if (onPdfClick) {
      onPdfClick();
      return;
    }

    handleNavigateTolLaudoViewer();
  }

  function handleAcessosClick(event: React.MouseEvent<HTMLButtonElement>) {
    event.stopPropagation();
    onAcessosClick?.();
  }

  return (
    <Container
      $selected={selected}
      $selectable={selectable}
      $visualizado={visualizado}
      onClick={selectable ? onSelect : undefined}
    >
      <NomePaciente visualizado={visualizado}>{nmPaciente}</NomePaciente>

      <Row>
        <Infos>
          {nrControle && <Info>{nrControle}</Info>}
          {dataExibida && <Info>{dataExibida}</Info>}
          {dsExame && <Info>{dsExame}</Info>}
          {visualizado && <Info>Visualizado: {dhVisualizacao}</Info>}

          {isConcluido && (
            <StatusConcluido>
              <TextStatus>Concluido</TextStatus>
            </StatusConcluido>
          )}
          {(status === undefined || status === 'EM ANDAMENTO') && (
            <StatusAguardando>
              <TextStatus>Em Andamento</TextStatus>
            </StatusAguardando>
          )}
        </Infos>

        {isConcluido && (
          <Actions>
            {isAdmin && (
              <AcessosButton
                type="button"
                title="Quem acessou"
                onClick={handleAcessosClick}
              >
                <Users size={20} weight="bold" color="#fff" />
              </AcessosButton>
            )}
            <Button
              type="button"
              disabled={pdfDisabled}
              onClick={handlePdfClick}
            >
              <Photo src={pdfImage} />
            </Button>
          </Actions>
        )}
      </Row>
    </Container>
  );
}
